import { useState } from "react";
import "./Stepper.scss";
import PropTypes from "prop-types";

const Step = ({ label, navigateToStepHandler, index, isActive }) => {
  const classes = [""];

  if (isActive) {
    classes.push("is-active");
  } else classes.push("is-not-active");

  return (
    <div className={`stepper-step ${classes.join(" ")}`}>
      <div
        className="stepper-indicator-info"
        onClick={() => navigateToStepHandler(index)}
      >
        {label}
      </div>
    </div>
  );
};

Step.propTypes = {
  label: PropTypes.string,
  navigateToStepHandler: PropTypes.func,
  index: PropTypes.number,
  isActive: PropTypes.bool,
};

const Stepper = ({ pages, getPageIndex, pageIndex, setPageIndex }) => {
  const navigateToStepHandler = (index) => {
    if (index < pageIndex || index === pageIndex + 1) {
      setPageIndex(index);
      getPageIndex(index);
    }
  };

  return (
    <div className="stepper-wrapper">
      <div style={{ display: "flex" }}>
        <div className={`stepper-head  inline-stepper-head`}>
          {pages?.map((el, i) => (
            <Step
              key={el}
              index={i}
              navigateToStepHandler={navigateToStepHandler}
              isActive={i <= pageIndex}
              label={el}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Stepper;

Stepper.propTypes = {
  pages: PropTypes.array,
  getPageIndex: PropTypes.func,
};
